
import MescrollVue from 'mescroll.js/mescroll.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Picker from 'vux/src/components/picker/index.vue'

import {queryhisalarm} from '../../api/device'

export default {
name: 'alarmNew',
components: {
Picker,
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
handleSuc: false,
showWarn: false,
warnText: '失败',
years1: [],
year4: [],
changeTime: [],
pickerShow: false,
yearMonth: '',
start: '',
end: '',
alarmData: [],
cnt: 10,
page: 1,
mescrollUp: { // 上拉加载的配置.
callback: this.upCallback,
isBoth: true,
dataList: [] 
},
alarmToast: false,
alarmItem: {},
content: '',
alarmHandle: false,
alarmid: '',
imgArr: [
{dtype: 700, imgUrl: 'static/alarmList/list_gateway.png'}, // 安防智能网关 (网关)
{dtype: 400, imgUrl: 'static/alarmList/list_lock.png'}, // 门锁 (网关)
{dtype: 300, imgUrl: 'static/alarmList/list_smoke.png'}, // nb烟感
{dtype: 99, imgUrl: 'static/alarmList/list_smoke.png'}, // nb烟感
{dtype: 200, imgUrl: 'static/alarmList/list_police.png'}, // 一键报警
{dtype: 501, imgUrl: 'static/alarmList/list_CO.png'}, // 一氧化碳
{dtype: 502, imgUrl: 'static/alarmList/list_gas.png'}, // 燃气
{dtype: 800, imgUrl: 'static/alarmList/list_police_gateway.png'}, // 一键报警网关 (网关)
{dtype: 503, imgUrl: 'static/alarmList/list_fire.png'}, // 灭火器压力表
{dtype: 504, imgUrl: 'static/alarmList/list_door_sensor.png'}, // NB门磁
{dtype: 505, imgUrl: 'static/alarmList/list_SOS_btn.png'}, // NB-SOS按钮 巡鹰
{dtype: 506, imgUrl: 'static/alarmList/list_smoke.png'}, // NB-烟感新
{dtype: 507, imgUrl: 'static/alarmList/list_SOS_btn.png'}, // NB-SOS按钮 西美
{dtype: 901, imgUrl: 'static/alarmList/list_W23.png'}, // Cat1 W23
{dtype: 902, imgUrl: 'static/alarmList/list_701SE.png'}, // Cat1 拉绳报警器

{dtype: -1, imgUrl: 'static/alarmList/list_alarmlamp.png'}, // 警灯
{dtype: 1, imgUrl: 'static/alarmList/list_CO.png'}, // 一氧化碳
{dtype: 2, imgUrl: 'static/alarmList/list_humiture_smoke.png'}, // 烟感
{dtype: 3, imgUrl: 'static/alarmList/list_gas.png'}, // 燃气
{dtype: 4, imgUrl: 'static/alarmList/list_door_sensor.png'}, // 门磁
{dtype: 5, imgUrl: 'static/alarmList/list_doorbell.png'}, // 门铃
{dtype: 6, imgUrl: 'static/alarmList/list_red.png'}, // 红外
{dtype: 7, imgUrl: 'static/alarmList/list_second_water.png'}, // 水浸
{dtype: 8, imgUrl: 'static/alarmList/list_control.png'}, // 遥控器
{dtype: 11, imgUrl: 'static/alarmList/list_humiture_smoke.png'}, // 温湿度烟感
{dtype: 12, imgUrl: 'static/alarmList/list_watergage.png'}, // 水压
{dtype: 13, imgUrl: 'static/alarmList/list_level.png'}, // 水位
{dtype: 51, imgUrl: 'static/alarmList/list_socket.png'}, // 智能开关
{dtype: 52, imgUrl: 'static/alarmList/list_humiture.png'}, // 温湿度
{dtype: 53, imgUrl: 'static/alarmList/list_lamp.png'}, // 智能灯泡
{dtype: 14, imgUrl: 'static/alarmList/list_door_sensor.png'}, // 门磁
{dtype: '', imgUrl: 'static/alarmList/list_default_father.png'} // 默认
]
}
},
created () {
this.alarmHandle = this.$store.getters.get_alarm_handle
this.alarmid = this.$store.getters.get_alarm_id
let years = []
let year1 = new Date().getFullYear()
for (let i = 2014; i <= year1; i++) {
years.push({
name: i + '年',
value: i + ''
})
}
this.years1 = [years, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]]
let year = new Date().getFullYear()
let month = new Date().getMonth() + 1

this.year4 = [year + '', month + '']
this.changeTime = [year + '', month + '']

this.yearMonth = year + '年' + month + '月'
this.getStartEnd()
},
methods: {
getShowVal (item) {
let show = false
if (item.subdid === 0) { // 主机
if (item.device !== null) {
if (item.device.dtype === 503 ||
item.device.dtype === 504) {
show = true
}
}
} else { // 子机
if (item.childdevice !== null) {
if (item.childdevice.dtype === 2 ||
item.childdevice.dtype === 12 ||
item.childdevice.dtype === 13 ||
item.childdevice.dtype === 52 ||
item.childdevice.dtype === 11 ||
item.childdevice.dtype === 14) {
show = true
}
}
}
return show
},
getOpenTime () {


this.year4 = this.changeTime
this.pickerShow = true
},
sendTime () {

this.changeTime = [this.year4[0], this.year4[1]]
this.yearMonth = this.changeTime[0] + '年' + this.changeTime[1] + '月'
this.getStartEnd()
this.pickerShow = false
setTimeout(() => {
let page = {num: 1, size: 10}
this.upCallback(page)
}, 100)
},
change (value) {

},
getStartEnd () {
console.log(900, this.changeTime)
let year = new Date().getFullYear() + ''
let month = new Date().getMonth() + 1 + ''
let day = new Date().getDate() + ''
let endMonth = this.changeTime[1].length === 1 ? '0' + this.changeTime[1] : this.changeTime[1]
let endDay = this.getDay(this.changeTime[0], this.changeTime[1])
if (this.changeTime[0] === year && this.changeTime[1] === month) {
let today = day.length === 1 ? '0' + day : day
this.start = this.changeTime[0] + '-' + endMonth + '-01'
this.end = this.common.GetDateStr(1, this.changeTime[0] + '-' + endMonth + '-' + today)
} else {
this.start = this.changeTime[0] + '-' + endMonth + '-01'
this.end = this.common.GetDateStr(1, this.changeTime[0] + '-' + endMonth + '-' + endDay)
}
},
getDay (year, month) {
let day31 = ['1', '3', '5', '7', '8', '10', '12']
let day30 = ['4', '6', '9', '11']
let day = ''
if (day31.indexOf(month) > -1) {
day = '31'
} else if (day30.indexOf(month) > -1) {
day = '30'
} else {

if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
day = '29'
} else {
day = '28'
}
}
return day
},

mescrollInit (mescroll) {
this.mescroll = mescroll 
},
upCallback (page, mescroll) {
let data = {
cnt: parseInt(this.cnt),
page: parseInt(page.num),
dids: [],
start: this.start,
end: this.end
}






this.alarmHandle = this.$store.getters.get_alarm_handle
this.alarmid = this.$store.getters.get_alarm_id
queryhisalarm(data).then(res => {
if (res.code === 200) {
if (res.data) {
let data = res.data
for (let i = 0; i < data.length; i++) {
if (data[i].config !== '' && typeof data[i].config === 'string') {
let config = JSON.parse(data[i].config)
while (typeof config === 'string') {
config = JSON.parse(config)
}
data[i].config = config
}
}
if (page.num === 1) {
this.alarmData = data
} else {
this.alarmData = this.alarmData.concat(data)
}
if (this.alarmHandle) {
for (let i = 0; i < this.alarmData.length; i++) {
if (parseInt(this.alarmid) === parseInt(this.alarmData[i].id)) {

this.handleAlarm(this.alarmData[i])
}
}
}
}
} else {
}
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(this.alarmData.length)
}, 100)
})
}).catch(() => {
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(0)
}, 100)
})
})
},

getImg (item) {

let dtype1 = parseInt(item.device.dtype)
let img = ''
if (item.childdevice === null) {
for (let i = 0; i < this.imgArr.length; i++) {
if (dtype1 === this.imgArr[i].dtype) {
img = this.imgArr[i].imgUrl
}
}
} else {
for (let i = 0; i < this.imgArr.length; i++) {
if (parseInt(item.childdevice.dtype) === this.imgArr[i].dtype) {
img = this.imgArr[i].imgUrl
}
}
}
if (img === '') {
return this.imgArr[this.imgArr.length - 1].imgUrl
} else {
return img
}
},
getDname (item) {
if (item.childdevice !== null) {
return item.device.name + '/' + item.childdevice.name
} else if (item.device) {
return item.device.name
} else {
return '未知设备'
}
},

getAlarmType (atype) {
return this.common.getAlarmType(atype)
},

getMPaName (pressure) {
return pressure / 1000000
},

getLevelName (level) {
return level / 100
},

handleAlarm (itme) {

if (itme.config !== '' && typeof itme.config === 'string') {
let config = JSON.parse(itme.config)
while (typeof config === 'string') {
config = JSON.parse(config)
}
itme.config = config
}
this.alarmItem = itme
this.alarmItem.dname = ''
this.content = ''
this.aid = itme.id
if (itme.childdevice !== null) {
this.did = itme.childdevice.id
this.alarmItem.dname = this.alarmItem.device.name + '/' + this.alarmItem.childdevice.name
} else {
this.did = itme.device.id
this.alarmItem.dname = this.alarmItem.device.name
}
this.alarmToast = true
},
closeHandle () {
this.$store.commit('set_alarm_handle', false)
this.$store.commit('set_alarm_id', '')
this.content = ''
this.alarmItem = {}
this.alarmToast = false
},

handleAlarmCommit () {
this.$store.commit('set_alarm_handle', false)
if (this.content === '') {
this.contentMsg = true
} else {
let body = {}
if (parseInt(this.content) === 1) {
body = {
did: this.did,
aid: this.aid,
content: '已处理'
}
} else if (parseInt(this.content) === 2) {
body = {
did: this.did,
aid: this.aid,
content: '误报'
}
}
this.$http.post(this.base + 'handlealarm?token=' + this.$store.getters.get_token, body).then(res => {

if (res.data.code === 200) {
this.handleSuc = true
this.alarmToast = false
let page = {num: 1, size: 10}
this.upCallback(page)
} else {
if (res.data.code === 20001 || res.data.code === 20002 || res.data.code === 20003 || res.data.code === 20004 || res.data.code === 20007) {
this.golobleObject.getHintOpen(res)
} else {
this.warnText = res.data.msg
this.showWarn = true
}
}
}).catch(error => {
if (error.response.data.code === 20001 || error.response.data.code === 20002 ||
error.response.data.code === 20003 || error.response.data.code === 20004 ||
error.response.data.code === 20007 || error.response.data.code === 30006) {
this.golobleObject.getHintOpen(error.response.data)
} else {
this.warnText = '失败'
this.showWarn = true
}
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/alarm/alarmNew.vue